import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

const Wrapper = styled.div`
    background-color: #EDEDED; 
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px;
    border: none !important;

    // Mobile version.
    @media (max-width: 768px) {
        background-color: #FFFFFF;
        padding-bottom: 64px !important;
    }

    > h2 {
        font-family: Lato-Light;
        font-size: 24px;
        font-weight: normal;

        color: #2B2B2B;
        text-align: left;
        line-height: 28px;
        margin-top: 0;
        margin-bottom: 11px;
        padding-bottom: 10px;
        border-bottom: 1px solid #CCCCCC;

        // Mobile version.
        @media (max-width: 768px) {
            padding-bottom: 0;
            border-bottom: none;
        }
    }

    > p, > ol {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        text-align: left;
        line-height: 22px;
    }

    > p {
        margin-top: 14px;
        margin-bottom: 0px;
    }

    > ol {
        margin-top: 5px;
        padding-left: 26px;
        margin-bottom: 0px;

        > li {
            padding-left: 8px;
        }
    }
`

class HowTo extends Component { 

    render() {
      const { content, employee } = this.props
      const contentJson = JSON.parse(content)

        if (!content) {
          return null
        }

        let htmlContent = ''

        contentJson.forEach(el => {
          if (el.broker_choice_cd !== employee.broker_choice_cd) {
            return
          }

          el.content.forEach(item => {
            if (item.header) {
              htmlContent += `<h2>${item.header}</h2>`
            } else if (item.list) {
              htmlContent += '<ol>'
              htmlContent += item.list.map(li => `<li>${li}</li>`).join('')
              htmlContent += '</ol>'
            } else {
              htmlContent += item.paragraphs.map(p => `<p>${p}</p>`).join('')
            }
          })
        })

        return <Wrapper dangerouslySetInnerHTML={{__html: htmlContent}}/>
    }
}

const mapState = state => ({
  employee: state.employee,
  content: state.static_content.how_to_content,
})

export default connect(mapState)(withTranslation('translations')(HowTo))
